export default "__VITE_ASSET__DqcZD_pL__"